import { GameType } from '../Types/Types';

export function findGameType(name: string, gameTypes: GameType[]): GameType {
    const NAME = name.toUpperCase();

    return gameTypes.find((gameType) => {
        if (gameType?.name.toUpperCase() === NAME || gameType?.slug.toUpperCase() === NAME) {
            return true;
        }

        if (gameType?.lottery_rule_tiers?.length > 0) {
            const found = gameType.lottery_rule_tiers.find(
                (tier) => tier.name.replace(/\s\([A-Za-z0-9-\s]+\)/, '').toUpperCase() === NAME
            );

            if (found) {
                return true;
            }
        }

        return false;
    });
}

export function supportStakes(stakeMin: number, stakeMax: number): boolean {
    return Math.abs(stakeMin - 1) > Number.EPSILON || Math.abs(stakeMax - 1) > Number.EPSILON;
}

export function getStakesSum(stakes: number[]): number {
    return stakes.reduce((prev, current) => prev + current, 0);
}
